export const INIT_CALCULATOR = 'CALCULATOR/INIT_CALCULATOR';
export const LOAD_DIRECTIONS = 'CALCULATOR/LOAD_DIRECTIONS';
export const LOAD_CURRENCIES = 'CALCULATOR/LOAD_CURRENCIES';
export const SET_AVAILABLE_COUNTRIES_IN = 'CALCULATOR/SET_AVAILABLE_COUNTRIES_IN';
export const SET_AVAILABLE_COUNTRIES_OUT = 'CALCULATOR/SET_AVAILABLE_COUNTRIES_OUT';
export const SET_AVAILABLE_CURRENCIES_IN = 'CALCULATOR/SET_AVAILABLE_CURRENCIES_IN';
export const SET_AVAILABLE_CURRENCIES_OUT = 'CALCULATOR/SET_AVAILABLE_CURRENCIES_OUT';
export const SET_COUNTRY_IN = 'CALCULATOR/SET_COUNTRY_IN';
export const SET_COUNTRY_OUT = 'CALCULATOR/SET_COUNTRY_OUT';
export const SET_AMOUNT_IN = 'CALCULATOR/SET_AMOUNT_IN';
export const SET_AMOUNT_OUT = 'CALCULATOR/SET_AMOUNT_OUT';
export const GET_EXCHANGE_RATE = 'CALCULATOR/GET_EXCHANGE';
export const SET_FEE = 'CALCULATOR/SET_FEE';
export const LOAD_DELIVERY_METHODS = 'CALCULATOR/LOAD_DELIVERY_METHODS';
export const LOAD_DELIVERY_METHODS_PROGRESS = 'CALCULATOR/LOAD_DELIVERY_METHODS_PROGRESS';
export const SET_DELIVERY_METHOD = 'CALCULATOR/SET_DELIVERY_METHOD';

const defaultState = {
    inProgress: true,
    directions: null,
    availableCountriesIn: null,
    availableCountriesOut: null,
    currencies: null,
    availableCurrenciesIn: null,
    availableCurrenciesOut: null,
    countryIn: null,
    countryOut: null,
    amountIn: null,
    amountOut: null,
    exchange: null,
    fee: null,
    availableDeliveryMethods: null,
    deliveryMethodsProgress: true,
    deliveryMethod: null,
};

export const CalculatorReducer = (state = defaultState, action) => {
    switch (action.type) {
    case INIT_CALCULATOR:
        return {
            ...state,
            inProgress: false,
        };
    case LOAD_DIRECTIONS:
        return {
            ...state,
            directions: action.payload,
        };
    case LOAD_CURRENCIES:
        return {
            ...state,
            currencies: action.payload,
        };
    case LOAD_DELIVERY_METHODS:
        return {
            ...state,
            availableDeliveryMethods: action.payload,
        };
    case LOAD_DELIVERY_METHODS_PROGRESS:
        return {
            ...state,
            deliveryMethodsProgress: action.payload,
        };
    case SET_AVAILABLE_COUNTRIES_IN:
        return {
            ...state,
            availableCountriesIn: action.payload,
        };
    case SET_AVAILABLE_COUNTRIES_OUT:
        return {
            ...state,
            availableCountriesOut: action.payload,
        };
    case SET_AVAILABLE_CURRENCIES_IN:
        return {
            ...state,
            availableCurrenciesIn: action.payload,
        };
    case SET_AVAILABLE_CURRENCIES_OUT:
        return {
            ...state,
            availableCurrenciesOut: action.payload,
        };
    case SET_COUNTRY_IN:
        return {
            ...state,
            countryIn: action.payload,
        };
    case SET_COUNTRY_OUT:
        return {
            ...state,
            countryOut: action.payload,
        };
    case SET_AMOUNT_IN:
        return {
            ...state,
            amountIn: action.payload,
        };
    case SET_AMOUNT_OUT:
        return {
            ...state,
            amountOut: action.payload,
        };
    case GET_EXCHANGE_RATE:
        return {
            ...state,
            exchange: action.payload,
        };
    case SET_FEE:
        return {
            ...state,
            fee: action.payload,
        };
    case SET_DELIVERY_METHOD:
        return {
            ...state,
            deliveryMethod: action.payload,
        };
    }

    return state;
};
